// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__18DuI","requiredAsterisk":"Info_requiredAsterisk__3ecxO"};